/**
 * Created by DejanK on 9/29/2017.
 */
import HTML from './edit-final-agreement.html'
import get from 'lodash/get';
import clone from 'lodash/clone';
import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';

export { HTML, BidFinalAgreementEditController as Controller }

BidFinalAgreementEditController.$inject = ['NotificationUtils', 'DataServer', '$state', '$q', 'rbDialog', 'MainAPI'];
function BidFinalAgreementEditController(notificationUtils, dataServer, $state, $q, dialog, mainAPI){
  const vm = this;
  let originalTemplate;

  vm.save = save;
  vm.cancel = toView;
  vm.onModelChanged = onModelChanged;

  $onInit();

  function $onInit(){
    vm.bidId = $state.params.bidId;

    notificationUtils.onLoad(()=>{
      return $q.all({
        template: mainAPI.getBidFinalAgreementTemplate(vm.bidId)
          .then(httpResponse => {
            originalTemplate = get(httpResponse, 'data.letter');
            return clone(originalTemplate)
          }),
        placeholders: dataServer.getHotelRfpFinalAgreementPlaceholders()
      });
    }, vm, 'model' )
  }


  function save(){
    const modelTemplate = vm.model.template;

    if (modelTemplate.length > 1000000) {
      showTemplateTooBigError()
    } else if(isEqual(originalTemplate, modelTemplate)){
      toView()
    } else {
      saveTemplate()
    }
  }

  function onModelChanged($event){ vm.model.template = $event.letter }

  function toView(){ $state.go('hotelRfp.bid.finalAgreement.send') }

  function showTemplateTooBigError() {
    dialog.show('error', {
        locals: {
          Error: {
            heading: 'Saving Template',
            title: 'Failed!',
            message: 'Letter template is too big.'
          }
        }
      }
    ).catch(noop)
  }

  function saveTemplate() {
    notificationUtils.onSave(() => {
      return mainAPI.updateBidFinalAgreementTemplate(vm.bidId, vm.model.template)
    }).then(toView, noop);
  }
}
